import { render, staticRenderFns } from "./NotifyContainer.vue?vue&type=template&id=1bbc0e6f&scoped=true"
var script = {}
import style0 from "./NotifyContainer.vue?vue&type=style&index=0&id=1bbc0e6f&prod&lang=scss&scoped=true"
import style1 from "./NotifyContainer.vue?vue&type=style&index=1&id=1bbc0e6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc0e6f",
  null
  
)

export default component.exports